// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"15":"videoBlock","125":"comments","131":"accordion","312":"reactDOM","313":"tourismEvents","414":"searchModal","451":"wrapDivs","554":"multiStepForm","574":"industryInsights","614":"industryEvents","622":"searchPage","644":"react","748":"learningResources","863":"newsArticles","896":"chatBot"}[chunkId] || chunkId) + ".js";
};